import { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toDate } from "../../../utils/toDate";

import classes from "../../../components/Modal.module.css";

import printIcon from "../../../assets/printer_icon.png";
import editIcon from "../../../assets/edit_icon.png";

import CustomButton from "../../../components/CustomButton";
import Modal from "../../../components/Modal";
import InformationDiv from "./InformationDiv";
import SectionDivider from "../../../components/SectionDivider";
import InformationBox from "../../../components/InformationBox";

export default function InformationModal({ selectedRow, handleClose }) {
  const { t } = useTranslation("general");

  const printRef = useRef(null);

  const handlePrint = () => window.print();

  return (
    <Modal
      title={t("invoiceDetails")}
      onClose={handleClose}
      footer={
        <section className={classes.actions}>
          {selectedRow.invoiceNumber ? null : (
            <CustomButton
              variant="blank"
              elementType={Link}
              title={t("edit")}
              to={`/editContainer/${selectedRow?.id}`}
              // onClick={handleEdit}
              state={selectedRow}
              icon={editIcon}
              iconSize={18}
            />
          )}
          <CustomButton
            title={t("print")}
            variant="gray"
            icon={printIcon}
            iconSize={18}
            onClick={handlePrint}
          />
        </section>
      }
    >
      <div className="printing-area" ref={printRef}>
        <InformationDiv title="supplier" value={selectedRow?.supplier?.name} />

        <InformationDiv title="customer" value={selectedRow?.customer?.name} />

        <InformationDiv
          title="invoiceNumber"
          value={selectedRow?.invoiceNumber}
        />

        <InformationDiv
          title="amountForSupplier"
          value={selectedRow?.amountForSupplier}
        />

        <InformationDiv
          title="abstractAmountForCustomer"
          value={selectedRow?.abstractAmountForCustomer}
        />

        <InformationDiv
          title="finalAmountForCustomer"
          value={selectedRow?.finalAmountForCustomer}
        />

        <InformationDiv title="Date" value={toDate(selectedRow?.date)} />

        <InformationDiv title="received" value={selectedRow?.received} />

        <InformationDiv title="left" value={selectedRow?.left} />

        <InformationDiv title="company" value={selectedRow?.subCompany?.name} />

        <InformationDiv title="createdBy" value={selectedRow?.user?.username} />

        {/* Containers info */}
        {selectedRow?.ShippedContainer?.length ? (
          <>
            <SectionDivider title="containersDetails" />
            {selectedRow?.ShippedContainer?.map((container, index, array) => (
              <>
                {/* Add a title for every container, if there are multiple */}
                {array?.length > 1 && (
                  <p className="bold-text">
                    {t("container")} {index + 1}:
                  </p>
                )}

                <InformationDiv
                  title="customerName"
                  value={container?.customer?.name}
                  key={index}
                />
                <InformationDiv
                  title="containerNumber"
                  value={container?.containerNumber}
                  key={index}
                />
                <InformationDiv
                  title="amountForSupplier"
                  value={container?.amountForSupplier}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="expectedArrivalDate"
                  value={toDate(container?.expectedArrivalDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="finalDestination"
                  value={container?.finalDestination}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="material"
                  value={container?.material}
                  key={index}
                  classList="ignore-in-print"
                />
                <div className="o-row">
                  <InformationDiv
                    title="numberOfBoxes"
                    value={container?.numberOfBoxes}
                    key={index}
                    classList="ignore-in-print"
                  />

                  <InformationDiv
                    title="measuringUnit"
                    value={container?.measuringUnit}
                    key={index}
                    classList="ignore-in-print"
                  />
                </div>
                <InformationDiv
                  title="unitPrice"
                  value={container?.unitPrice}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="shipper"
                  value={container?.shipper}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="shippingDate"
                  value={toDate(container?.shippingDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="subCompany"
                  value={selectedRow?.subCompany?.name}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="exitDate"
                  value={toDate(container?.exitDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="abstractAmountForCustomer"
                  value={container?.abstractAmountForCustomer}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="finalAmountForCustomer"
                  value={container?.finalAmountForCustomer}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="dateOfEntry"
                  value={toDate(container?.dateOfEntry)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="howWasPapersReceived"
                  // Here, we have to translate the value too.
                  value={t(container?.howWasPapersReceived)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="permitsReceivingDate"
                  value={toDate(container?.permitsReceivingDate)}
                  key={index}
                  classList="ignore-in-print"
                />
                <InformationDiv
                  title="notes"
                  value={container?.notes}
                  key={index}
                  classList="ignore-in-print"
                />

                {/* Add a rule for all containers, except the last one */}
                {array.length - 1 > index && (
                  <div className="horizontal-rule"></div>
                )}
              </>
            ))}
          </>
        ) : (
          <InformationBox>{t("noContainers")}</InformationBox>
        )}
      </div>
    </Modal>
  );
}
